import './App.css';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import PrivacyPolicy from './pages/privacy_policy.js'
import Home from './pages/home.js';

function App() {
  return (
      <BrowserRouter>
        <Routes>
            <Route path="/" element={<Home/>}/>
            <Route path="/privacy" element={<PrivacyPolicy/>}/>
        </Routes>
      </BrowserRouter>
  );
}

export default App;
